import { BoardColumns } from "@/components/admin/BoardColumns";
import { BoardHeader, BoardSummary, EmailOffNotice } from "@/components/admin/LeadBoardLayout";
import { CompareDialog } from "@/components/admin/CompareDialog";
import { LeadSheet } from "@/components/admin/LeadSheet";
import { OutcomeBreakdown } from "@/components/admin/OutcomeBreakdown";
import { OutcomeDialog } from "@/components/admin/OutcomeDialog";
import { useLeadBoard } from "@/components/admin/useLeadBoard";

/**
 * The follow-up board.
 *
 * `useLeadBoard` owns the board and every move on it, `leadBoardState` does the
 * column arithmetic, and the columns, the lead sheet and the two dialogs are
 * each their own component - this file just puts them in order.
 */
export const LeadBoard = ({ onAuthError }) => {
  const board = useLeadBoard(onAuthError);

  return (
    <div data-testid="lead-board" className="p-4 sm:p-5">
      <BoardHeader
        quietDays={board.quietDays}
        query={board.query}
        onQuery={board.setQuery}
        service={board.serviceFilter}
        onService={board.setServiceFilter}
      />

      <BoardSummary
        summary={board.summary}
        quietDays={board.quietDays}
        loading={board.loading}
      />

      {board.board && !board.emailConfigured ? (
        <EmailOffNotice message={board.board.email.message} />
      ) : null}

      <BoardColumns board={board} />

      <LeadSheet
        lead={board.active}
        stages={board.stages}
        reasons={board.reasons}
        emailConfigured={board.emailConfigured}
        onClose={() => board.setActive(null)}
        onSaved={board.applyLead}
        onOutcomeNeeded={board.setOutcomePrompt}
        onCompare={(lead) => {
          board.setCompareLead(lead);
          board.setActive(null);
        }}
      />

      <CompareDialog
        lead={board.compareLead}
        onClose={() => {
          board.setActive(board.compareLead);
          board.setCompareLead(null);
        }}
      />

      <OutcomeDialog
        prompt={board.outcomePrompt}
        onClose={() => board.setOutcomePrompt(null)}
        onSaved={board.applyLead}
      />

      {board.board ? <OutcomeBreakdown outcomes={board.board.outcomes} /> : null}
    </div>
  );
};
